/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as TermsImport } from './routes/terms'
import { Route as SettingsImport } from './routes/settings'
import { Route as ProfileImport } from './routes/profile'
import { Route as PrivacyImport } from './routes/privacy'
import { Route as AuthImport } from './routes/_auth'
import { Route as IndexImport } from './routes/index'
import { Route as TechniquesIndexImport } from './routes/techniques/index'
import { Route as SystemsIndexImport } from './routes/systems/index'
import { Route as TechniquesIdImport } from './routes/techniques/$id'
import { Route as SystemsIdImport } from './routes/systems/$id'
import { Route as AuthVerifyImport } from './routes/_auth.verify'
import { Route as AuthSignupImport } from './routes/_auth.signup'
import { Route as AuthSigninImport } from './routes/_auth.signin'
import { Route as AuthResetImport } from './routes/_auth.reset'
import { Route as AuthForgotImport } from './routes/_auth.forgot'
import { Route as TechniquesIdEditImport } from './routes/techniques/$id_.edit'
import { Route as SystemsShareDataImport } from './routes/systems/share.$data'
import { Route as SystemsIdEditImport } from './routes/systems/$id_.edit'

// Create/Update Routes

const TermsRoute = TermsImport.update({
  path: '/terms',
  getParentRoute: () => rootRoute,
} as any)

const SettingsRoute = SettingsImport.update({
  path: '/settings',
  getParentRoute: () => rootRoute,
} as any)

const ProfileRoute = ProfileImport.update({
  path: '/profile',
  getParentRoute: () => rootRoute,
} as any)

const PrivacyRoute = PrivacyImport.update({
  path: '/privacy',
  getParentRoute: () => rootRoute,
} as any)

const AuthRoute = AuthImport.update({
  id: '/_auth',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const TechniquesIndexRoute = TechniquesIndexImport.update({
  path: '/techniques/',
  getParentRoute: () => rootRoute,
} as any)

const SystemsIndexRoute = SystemsIndexImport.update({
  path: '/systems/',
  getParentRoute: () => rootRoute,
} as any)

const TechniquesIdRoute = TechniquesIdImport.update({
  path: '/techniques/$id',
  getParentRoute: () => rootRoute,
} as any)

const SystemsIdRoute = SystemsIdImport.update({
  path: '/systems/$id',
  getParentRoute: () => rootRoute,
} as any)

const AuthVerifyRoute = AuthVerifyImport.update({
  path: '/verify',
  getParentRoute: () => AuthRoute,
} as any)

const AuthSignupRoute = AuthSignupImport.update({
  path: '/signup',
  getParentRoute: () => AuthRoute,
} as any)

const AuthSigninRoute = AuthSigninImport.update({
  path: '/signin',
  getParentRoute: () => AuthRoute,
} as any)

const AuthResetRoute = AuthResetImport.update({
  path: '/reset',
  getParentRoute: () => AuthRoute,
} as any)

const AuthForgotRoute = AuthForgotImport.update({
  path: '/forgot',
  getParentRoute: () => AuthRoute,
} as any)

const TechniquesIdEditRoute = TechniquesIdEditImport.update({
  path: '/techniques/$id/edit',
  getParentRoute: () => rootRoute,
} as any)

const SystemsShareDataRoute = SystemsShareDataImport.update({
  path: '/systems/share/$data',
  getParentRoute: () => rootRoute,
} as any)

const SystemsIdEditRoute = SystemsIdEditImport.update({
  path: '/systems/$id/edit',
  getParentRoute: () => rootRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_auth': {
      preLoaderRoute: typeof AuthImport
      parentRoute: typeof rootRoute
    }
    '/privacy': {
      preLoaderRoute: typeof PrivacyImport
      parentRoute: typeof rootRoute
    }
    '/profile': {
      preLoaderRoute: typeof ProfileImport
      parentRoute: typeof rootRoute
    }
    '/settings': {
      preLoaderRoute: typeof SettingsImport
      parentRoute: typeof rootRoute
    }
    '/terms': {
      preLoaderRoute: typeof TermsImport
      parentRoute: typeof rootRoute
    }
    '/_auth/forgot': {
      preLoaderRoute: typeof AuthForgotImport
      parentRoute: typeof AuthImport
    }
    '/_auth/reset': {
      preLoaderRoute: typeof AuthResetImport
      parentRoute: typeof AuthImport
    }
    '/_auth/signin': {
      preLoaderRoute: typeof AuthSigninImport
      parentRoute: typeof AuthImport
    }
    '/_auth/signup': {
      preLoaderRoute: typeof AuthSignupImport
      parentRoute: typeof AuthImport
    }
    '/_auth/verify': {
      preLoaderRoute: typeof AuthVerifyImport
      parentRoute: typeof AuthImport
    }
    '/systems/$id': {
      preLoaderRoute: typeof SystemsIdImport
      parentRoute: typeof rootRoute
    }
    '/techniques/$id': {
      preLoaderRoute: typeof TechniquesIdImport
      parentRoute: typeof rootRoute
    }
    '/systems/': {
      preLoaderRoute: typeof SystemsIndexImport
      parentRoute: typeof rootRoute
    }
    '/techniques/': {
      preLoaderRoute: typeof TechniquesIndexImport
      parentRoute: typeof rootRoute
    }
    '/systems/$id/edit': {
      preLoaderRoute: typeof SystemsIdEditImport
      parentRoute: typeof rootRoute
    }
    '/systems/share/$data': {
      preLoaderRoute: typeof SystemsShareDataImport
      parentRoute: typeof rootRoute
    }
    '/techniques/$id/edit': {
      preLoaderRoute: typeof TechniquesIdEditImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren([
  IndexRoute,
  AuthRoute.addChildren([
    AuthForgotRoute,
    AuthResetRoute,
    AuthSigninRoute,
    AuthSignupRoute,
    AuthVerifyRoute,
  ]),
  PrivacyRoute,
  ProfileRoute,
  SettingsRoute,
  TermsRoute,
  SystemsIdRoute,
  TechniquesIdRoute,
  SystemsIndexRoute,
  TechniquesIndexRoute,
  SystemsIdEditRoute,
  SystemsShareDataRoute,
  TechniquesIdEditRoute,
])

/* prettier-ignore-end */
